import { createContext, useContext } from 'react'
import { Customer } from 'src/generated/client'

export const CustomerContext = createContext<Customer | undefined>({})

export const useCustomer = () => useContext(CustomerContext)
